<!-- src/App.vue -->

<template>
  <div id="app">
        <router-view></router-view>
  </div>
  <main>
    <PostPagePart1Content :id="id"/>

  </main>
</template>


<script>
  import PostPagePart1Content from '@/PostPagePart1Content.vue'; 
  import 'animate.css';
  export default {
    name: 'PostPage',
    props: ['id'], // Add this to receive the id prop from router
    components: {
      PostPagePart1Content,
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      }
    },
  }

</script>